import { render, staticRenderFns } from "./InboundSchedule.vue?vue&type=template&id=8478c90c"
import script from "./InboundSchedule.vue?vue&type=script&lang=js"
export * from "./InboundSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8478c90c')) {
      api.createRecord('8478c90c', component.options)
    } else {
      api.reload('8478c90c', component.options)
    }
    module.hot.accept("./InboundSchedule.vue?vue&type=template&id=8478c90c", function () {
      api.rerender('8478c90c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Inbound/InboundSchedule.vue"
export default component.exports